import { z } from 'zod';
import { CoreCommunicationEmailSuppressionListScopeTypeSchema } from '../inputTypeSchemas/CoreCommunicationEmailSuppressionListScopeTypeSchema'

/////////////////////////////////////////
// CORE COMMUNICATION EMAIL SUPPRESSION LIST SCHEMA
/////////////////////////////////////////

export const CoreCommunicationEmailSuppressionListSchema = z.object({
  scope: CoreCommunicationEmailSuppressionListScopeTypeSchema,
  id: z.number().int(),
  cityId: z.number().int().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  email: z.string(),
})

export type CoreCommunicationEmailSuppressionList = z.infer<typeof CoreCommunicationEmailSuppressionListSchema>

export default CoreCommunicationEmailSuppressionListSchema;
